export default {
      id: "sport-usage",
      viewBox: "0 0 37.8 37.8",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#sport",
      toString: function () {
        return this.url;
      }
    }